<script>
  import SideNav from "./components/SideNav/SideNav.svelte"
  import Router from 'svelte-spa-router'
  import routes from './routes'

  export let name;
</script>


<SideNav/>
<body>
<div class="content-start pl-16">
    <Router {routes}/>
</div>
</body>

<style>
    main {
        text-align: center;
        padding: 1em;
        max-width: 240px;
        margin: 0 auto;
    }

    h1 {
        color: #ff3e00;
        text-transform: uppercase;
        font-size: 4em;
        font-weight: 100;
    }

    @media (min-width: 640px) {
        main {
            max-width: none;
        }
    }
</style>
